<template>
  <transition name="fade">
    <div class="modal" v-if="show">
      <div class="modalOverlay"></div>
      <div class="modalContent">
        <div class="loading" v-if="loading"></div>
        <h4>Banner Editor</h4>
        <form v-on:submit.prevent="handleSubmit">
          <div class="imgCnt">
            <div :class="{sliderImg: true, hasError: imgError}"
              v-on:click="changeImg" v-if="!image">
              <div class="addPhoto">
                <img src="../assets/photo-black.png">
                <span>Background Image</span>
              </div>
            </div>
            <div class="sliderImg" v-on:click="changeImg" v-else
              :style="{'background-image': `url(${image.imageMd})`}">
              <div class="addPhoto changePhoto">
                <div>
                  <img src="../assets/photo-white.png">
                  <span>Change Background</span>
                </div>
              </div>
            </div>
            <div :class="{sliderImg: true, thumbImg: true, hasError: imgError}"
              v-on:click="changeRightImg" v-if="!rightImage">
              <div class="addPhoto">
                <img src="../assets/photo-black.png">
                <span>Right Image</span>
              </div>
            </div>
            <div class="sliderImg thumbImg" v-on:click="changeRightImg" v-else
              :style="{'background-image': `url(${rightImage.imageMd})`}">
              <div class="addPhoto changePhoto">
                <div>
                  <img src="../assets/photo-white.png">
                  <span>Change Image</span>
                </div>
              </div>
            </div>
          </div>
          <div class="imgError" v-if="imgError">Please select image to continue.</div>
          <div :class="{fieldGroup: true, hasError: form.title.error}">
            <input type="text" class="field" placeholder="Title"
              v-model="form.title.model" v-on:input="fieldChanged">
            <div class="fieldError">Please input title to continue.</div>
          </div>
          <div :class="{fieldGroup: true, hasError: form.description.error}">
            <textarea placeholder="Description..."
              class="field" rows="4" v-model="form.description.model"/>
            <div class="fieldHint">Write something about this slide.</div>
          </div>
          <div :class="{fieldGroup: true, hasError: form.buttonLabel.error}">
            <input type="text" class="field" placeholder="Button Label"
              v-model="form.buttonLabel.model" v-on:input="fieldChanged">
            <div class="fieldError">Set blank for not displaying button.</div>
          </div>
          <div :class="{fieldGroup: true, hasError: form.buttonUrl.error}">
            <input type="text" class="field" placeholder="Button Url"
              v-model="form.buttonUrl.model" v-on:input="fieldChanged">
          </div>

          <div class="modalAction">
            <button class="btn btnSecondary" type="button"
              v-on:click="close(false)">Cancel</button>
            <button class="btn btnPrimary" type="submit">
              <span>Save</span>
            </button>
          </div>
        </form>
      </div>
      <Confirmation ref="confirmDialog"/>
      <FormInputerShort ref="formInputer"/>
      <MediaSelector ref="mediaSelector"/>
    </div>
  </transition>
</template>

<script>
import Confirmation from '@/components/Confirmation.vue';
import FormInputerShort from '@/components/FormInputerShort.vue';
import MediaSelector from '@/components/MediaSelector.vue';

export default {
  name: 'addArticleCategory',
  components: {
    Confirmation,
    FormInputerShort,
    MediaSelector,
  },
  data() {
    return {
      show: false,
      loading: false,
      data: null,
      form: {
        title: { model: '', error: null },
        description: { model: '', error: null },
        buttonLabel: { model: '', error: null },
        buttonUrl: { model: '', error: null },
      },
      image: null,
      imgError: false,
      rightImage: null,
      next: null,
    };
  },
  methods: {
    open(d, n) {
      this.data = d;
      this.image = (d && d.bgImg) ? d.bgImg : null;
      this.rightImage = (d && d.rightImg) ? d.rightImg : null;
      this.imgError = null;
      this.form.title.model = (d && d.title) ? d.title : '';
      this.form.description.model = (d && d.description) ? d.description : '';
      this.form.buttonLabel.model = (d && d.buttonLabel) ? d.buttonLabel : '';
      this.form.buttonUrl.model = (d && d.uri) ? d.uri : '';
      this.next = n;
      this.show = true;
    },
    close(b, d) {
      this.show = false;
      if (this.next && typeof this.next === 'function') this.next(b, d);
    },
    changeRightImg() {
      this.$refs.mediaSelector.open({}, (b, media) => {
        if (!b) return;
        this.rightImage = media;
      });
    },
    changeImg() {
      this.$refs.mediaSelector.open({}, (b, media) => {
        if (!b) return;
        this.image = media;
        this.imgError = false;
      });
    },
    handleSubmit() {
      if (!this.image || !this.rightImage) {
        this.imgError = true;
        return;
      }
      this.loading = true;
      const formData = {
        title: this.form.title.model,
        description: this.form.description.model,
        buttonLabel: this.form.buttonLabel.model,
        buttonUrl: this.form.buttonUrl.model,
        bgImg: this.image.id,
        rightImg: this.rightImage.id,
      };
      if (this.data) formData.id = this.data.id;
      this.$http.post(this.$config.uri('misc/banner/bodykey'), formData).then((r) => {
        this.loading = false;
        this.close(true, r.data.data);
      });
    },
    fieldChanged() {},
  },
};
</script>

<style scoped lang="scss">
  .modal{
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    z-index: 99;
    display: flex;
    align-items: center;
    justify-content: center;
    .modalOverlay{
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: rgba(0,0,0,.7);
      // backdrop-filter: saturate(180%) blur(20px);
      z-index: 1;
      opacity: 1;
    }
    .modalContent{
      position: absolute;
      background-color: #fff;
      z-index: 2;
      padding: 30px 80px;
      border-radius: 5px;
      margin-top: -20px;
      text-align: center;
      overflow: hidden;
      max-width: none;
      width: 400px;
      .imgCnt{
        display: flex;
      }
      .sliderImg{
        height: 140px;
        width: calc(100% - 150px);
        background-color: #eee;
        border-radius: 7px;
        margin-bottom: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: background-color .3s ease;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        background-size: cover;
        background-position: center;
        &.thumbImg{
          width: 140px;
          margin-left: 10px;
        }
        .addPhoto{
          color: #999;
          font-weight: bold;
          font-size: 13px;
          transition: all .3s ease;
          img{
            height: 36px;
            opacity: .3;
            display: block;
            margin: 0 auto 6px;
            transition: all .3s ease;
          }
          &.changePhoto{
            color: #fff;
            opacity: 0;
            background-color: rgba(0,0,0,.5);
            position: absolute;
            top: 0; left: 0; right: 0; bottom: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            img{
              opacity: 1;
            }
          }
        }
        &:hover{
          background-color: #e5e5e5;
          .addPhoto{
            color: #767676;
            img{
              opacity: .4;
            }
            &.changePhoto{
              opacity: 1;
              color: #fff;
              img{
                opacity: 1;
              }
            }
          }
        }
        &.hasError{
          border: red 2px solid;
          box-sizing: border-box;
          background-color: #fff3f3;
        }
      }
      .imgError{
        text-align: left;
        color: red;
        margin: -12px 7px 20px;
        font-size: 13px;
      }
      .loading{
        position: absolute;
        top: 0; left: 0; right: 0; bottom: 0;
        background-color: #fff;
        background-color: rgba(255,255,255,.7);
        backdrop-filter: saturate(180%) blur(20px);
        background-image: url(../assets/loading.svg);
        background-position: center;
        background-size: 70px auto;
        background-repeat: no-repeat;
        z-index: 9;
      }
      .fieldGroup{
        label.checkLabel{
          text-align: left;
          text-transform: none;
          color: #444;
          margin: 0;
          padding: 5px 0;
          cursor: pointer;
          font-size: 17px;
          font-weight: 600;
          input{
            margin: 0;
            margin-left: 3px;
            margin-top: 4px;
            margin-right: 10px;
            float: left;
          }
        }
      }
      textarea{
        margin-top: 20px;
      }
      h4{
        margin: 0;
        font-size: 24px;
        font-weight: normal;
        margin-bottom: 20px;
        color: #444;
        text-align: left;
      }
      p{
        margin: 0;
        color: #767676;
      }
      .modalAction{
        margin: 30px -80px -30px;
        padding: 12px 30px;
        text-align: right;
        // background-color: #eee;
        border-top: #eee 1px solid;
        position: relative;
        .deleteCat{
          position: absolute;
          left: 30px; top: 22px;
          color: red; cursor: pointer;
          padding-left: 22px;
          opacity: .8;
          &:before{
            display: block;
            content: "";
            position: absolute;
            left: 0; top: 0;
            width: 16px; height: 20px;
            background-image: url(../assets/delete.png);
            background-size: 14px auto;
            background-position: center;
            background-repeat: no-repeat;
          }
          &:hover{
            opacity: 1;
          }
        }
        .btn{
          margin-left: 10px;
        }
      }
    }
  }
</style>
